module.exports = __webpack_public_path__ + "static/widget-img-7-049ceb92a08526549311a2e3ab65c3b5.png";